import { Module, Mutation } from 'vuex-module-decorators'
import { defaultSystemCode, SystemCode } from '@/api'
import BaseStore from '@/store/BaseStore'

export interface modalShelfDiagramInterface {
  shelfType: SystemCode
  holdingBranch: SystemCode
}

@Module({
  name: 'ModalShelfDiagramStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalShelfDiagramStore extends BaseStore {
  _isOpen = false

  _shelfType: SystemCode = defaultSystemCode()

  _holdingBranch: SystemCode = defaultSystemCode()

  get isOpen(): boolean {
    return this._isOpen
  }

  get shelfType(): SystemCode {
    return this._shelfType
  }

  get holdingBranch(): SystemCode {
    return this._holdingBranch
  }

  @Mutation
  public open(params: modalShelfDiagramInterface) {
    this._isOpen = true
    this._shelfType = params.shelfType
    this._holdingBranch = params.holdingBranch
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public ok() {
    this._isOpen = false
  }
}
